var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5312C13.4766 16.5312 17.1641 12.8359 17.1641 8.35938C17.1641 3.88281 13.4688 0.195312 9 0.195312C4.52344 0.195312 0.835938 3.88281 0.835938 8.35938C0.835938 12.8359 4.52344 16.5312 9 16.5312ZM11.5391 10.6016C11.0859 10.6016 10.7969 10.2812 10.7969 9.78125V8.57812L10.9062 7.49219L9.88281 8.63281L7.17188 11.3359C6.99219 11.5234 6.78125 11.6016 6.53125 11.6016C6.07031 11.6016 5.71094 11.2734 5.71094 10.7812C5.71094 10.5625 5.8125 10.3359 5.97656 10.1719L8.70312 7.45312L9.85156 6.42188L8.82031 6.54688H7.53906C7.03906 6.54688 6.71875 6.25781 6.71875 5.80469C6.71875 5.35156 7.03906 5.0625 7.53906 5.0625H11.3125C11.9141 5.0625 12.2812 5.38281 12.2812 6.01562V9.77344C12.2812 10.2656 11.9922 10.6016 11.5391 10.6016Z",
    fill: "#768299"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.430df00c.svg";
export { ForwardRef as ReactComponent };